import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

const COLORS = ["#2563eb", "#22c55e", "#f97316", "#ef4444", "#a855f7", "#0ea5e9"];

const ClientsStats = () => {
  const [clients, setClients] = useState([]);
  const [clientsactive, setClientsactive] = useState([]);
  const [clientsThisMonth, setClientsThisMonth] = useState(0);

  useEffect(() => {
    axios.get("/client")
      .then((res) => {
        const data = res.data;
        setClients(data);
        const clientac=data.filter((c) => c.deletedAt === null)
        setClientsactive(clientac)
        const now = new Date();
        const thisMonthCount = data.filter(client => {
          const createdAt = new Date(client.createdAt);
          return (
            createdAt.getMonth() === now.getMonth() &&
            createdAt.getFullYear() === now.getFullYear()
          );
        }).length;

        setClientsThisMonth(thisMonthCount);
      })
      .catch((err) => console.error("Erreur de récupération des clients", err));
  }, []);

  const activeClients = clients.filter((c) => c.deletedAt === null).length;
  const deletedClients = clients.length - activeClients;

  const pieData = [
    { name: "Ajoutés ce mois", value: clientsThisMonth },
    { name: "Autres", value: clients.length - clientsThisMonth },
  ];

  const statusData = [
    { name: "Actifs", value: activeClients },
    { name: "Supprimés", value: deletedClients },
    { name: "Total", value: clients.length },
  ];

  const projectData = clientsactive.map((client) => ({
    name: client.name,
    projets: client.projects?.length || 0,
  }));

  const renderLabel = ({ name, percent }) =>
    `${name} (${(percent * 100).toFixed(0)}%)`;

return (
  <div
    style={{
      display: "flex",
      justifyContent: "center", // centre les 3 charts horizontalement
      marginTop: "40px",
    }}
  >
    {/* Pie chart */}
    <div
      style={{
        flex: "0 0 33.333%",
        display: "flex",
        justifyContent: "center", // centre le chart dans sa colonne
        alignItems: "center",
      }}
    >
      <ResponsiveContainer width="90%" height={230}>
        <PieChart>
          <Pie
            data={pieData}
            cx="50%"
            cy="50%"
            outerRadius={70}
            label={renderLabel}
            dataKey="value"
          >
            {pieData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Legend verticalAlign="bottom" height={30} />
        </PieChart>
      </ResponsiveContainer>
    </div>

    {/* Bar chart 1 */}
    <div
      style={{
        flex: "0 0 33.333%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ResponsiveContainer width="90%" height={180}>
        <BarChart
          data={statusData}
          margin={{ top: 10, right: 20, left: 20, bottom: 40 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" type="category" tick={{ fontSize: 10 }} />
          <YAxis type="number" tick={{ fontSize: 10 }} />
          <Tooltip />
          <Bar dataKey="value" fill="#2563eb" barSize={24} />
        </BarChart>
      </ResponsiveContainer>
    </div>

    {/* Bar chart 2 */}
    <div
      style={{
        flex: "0 0 33.333%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      
      <ResponsiveContainer width="90%" height={180}>
        <BarChart
          data={clientsactive.map((c) => ({
            name: c.name,
            projets: c.projects?.length || 0,
          }))}
          margin={{ top: 10, right: 20, left: 20, bottom: 40 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            type="category"
            tick={{ fontSize: 9, angle: -45, textAnchor: "end" }}
          />
          <YAxis type="number" tick={{ fontSize: 10 }} />
          <Tooltip />
          <Bar dataKey="projets" fill="#22c55e" barSize={24} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
);



};

export default ClientsStats;
